import { create } from 'zustand';

import { ReviewOrderBy } from '@notino/shared/definitions/types';

import { IOrderBy } from '@containers/ProductDetailContainer/model';

interface State {
  orderBy: ReviewOrderBy;
  orderDesc: boolean;
  page: number;
  nextPage: number;
  hideTranslated: boolean;
  allowHideTranslatedCheckbox: boolean;
}

interface ReviewSortingState extends State {
  actions: {
    changeOrder: (order: IOrderBy) => void;
    incNextPage: () => void;
    resetNextPage: () => void;
    toggleHideTranslatedReviews: () => void;
  };
}

const initialState: State = {
  orderBy: ReviewOrderBy.DateTime,
  orderDesc: true,
  page: 1,
  nextPage: 2,
  hideTranslated: false,
  allowHideTranslatedCheckbox: false,
};

export const useReviewSortingStore = create<ReviewSortingState>((set) => ({
  ...initialState,
  actions: {
    changeOrder: (order) =>
      set((state) => {
        if (state.orderBy === order.key && state.orderDesc === order.desc) {
          return state;
        }
        return {
          orderBy: order.key,
          orderDesc: order.desc,
          page: 1,
          nextPage: 2,
        };
      }),
    incNextPage: () =>
      set((state) => ({
        nextPage: state.nextPage + 1,
      })),
    resetNextPage: () =>
      set(() => ({
        nextPage: 2,
      })),
    toggleHideTranslatedReviews: () =>
      set((state) => ({
        hideTranslated: !state.hideTranslated,
        allowHideTranslatedCheckbox:
          state.allowHideTranslatedCheckbox || !state.hideTranslated,
      })),
  },
}));

export const useReviewSortingActions = () =>
  useReviewSortingStore((s) => s.actions);
